import { STATIC_ASSETS_URL } from "common/context/constants"

export function DocumentCreation({ handleOnClick, sub }: $TSMigrationFixMe) {
  return (
    <div
      onClick={() => handleOnClick(sub.path)}
      className={`${"direct-access-card"} d-flex flex-column justify-content-around tw-cursor-pointer hover:tw-bg-gray-50`}
    >
      <div className={`item-new ${"mt-4"}`}>
        <div className='direct-access-icon d-flex items-center justify-content-center mb-5'>
          <img
            src={`${STATIC_ASSETS_URL}/Imagenes/Ilustraciones/${sub.nameIcon}`}
            alt={sub?.nameIcon}
            className='iconsDirectAccess'
          />
        </div>

        <div className='text-black d-flex items-center justify-content-center mt-2'>
          {sub.text}
        </div>
      </div>
    </div>
  )
}
